import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../api/api';
import AppLayout from '../components/AppLayout';
import PageTitle from '../components/PageTitle';
import '../styles/pages/ResetPasswordPage.css';

const ResetPasswordPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'パスワード再設定 | はしもと栄養パートナー';
  }, []);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('パスワードが一致しません');
      return;
    }

    if (password.length < 8) {
      setError('パスワードは8文字以上である必要があります');
      return;
    }

    setLoading(true);

    try {
      await api.post(`/api/auth/reset-password/${token}`, {
        password,
        confirmPassword
      });

      setSuccess(true);
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (error) {
      setError(error.response?.data?.message || 'パスワードリセットに失敗しました');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <AppLayout hideTabNav>
        <PageTitle title="パスワードリセット完了" subtitle="成功しました" icon="✅" />
        <div className="tsumugi-container py-6">
          <div className="max-w-md mx-auto">
            <div className="tsumugi-card text-center">
              <div className="reset-password-page__success-icon-wrapper">
                <svg className="reset-password-page__success-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="reset-password-page__success-title">
                パスワードリセット完了
              </h2>
              <div className="reset-password-page__success-box">
                <p className="reset-password-page__success-message">
                  パスワードが正常にリセットされました。<br />
                  3秒後にログインページに移動します。
                </p>
              </div>
              <Link
                to="/login"
                className="tsumugi-btn-primary inline-block"
              >
                今すぐログインページに移動
              </Link>
            </div>
          </div>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout hideTabNav>
      <PageTitle title="パスワード再設定" subtitle="新しいパスワードを設定してください" icon="🔐" />
      <div className="tsumugi-container py-6">
        <div className="max-w-md mx-auto">
          <form onSubmit={handleSubmit}>
            <div className="tsumugi-card space-y-4">
              {error && (
                <div className="reset-password-page__error-box">
                  {error}
                </div>
              )}

              <div>
                <label htmlFor="password" className="reset-password-page__label">
                  新しいパスワード
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="new-password"
                  required
                  className="reset-password-page__input"
                  placeholder="新しいパスワード（8文字以上）"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  minLength="8"
                />
              </div>

              <div>
                <label htmlFor="confirmPassword" className="reset-password-page__label">
                  パスワード確認
                </label>
                <input
                  id="confirmPassword"
                  name="confirmPassword"
                  type="password"
                  autoComplete="new-password"
                  required
                  className="reset-password-page__input"
                  placeholder="パスワードを再入力"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  minLength="8"
                />
              </div>

              {/* パスワード要件の表示 */}
              <div className="reset-password-page__requirements">
                <h4 className="reset-password-page__requirements-title">パスワードの要件:</h4>
                <ul className="reset-password-page__requirements-list">
                  <li className={password.length >= 8 ? 'valid' : ''}>
                    • 8文字以上
                  </li>
                  <li className={password === confirmPassword && password ? 'valid' : ''}>
                    • 確認パスワードと一致
                  </li>
                </ul>
              </div>

              <div>
                <button
                  type="submit"
                  disabled={loading || password !== confirmPassword || password.length < 8}
                  className="tsumugi-btn-primary w-full disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? (
                    <div className="flex items-center justify-center">
                      <div className="animate-spin -ml-1 mr-3 h-5 w-5">
                        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                      </div>
                      設定中...
                    </div>
                  ) : (
                    'パスワードを更新'
                  )}
                </button>
              </div>

              <div className="text-center">
                <Link to="/login" className="reset-password-page__login-link">
                  ログインページに戻る
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </AppLayout>
  );
};

export default ResetPasswordPage;
